/*
 * @Descripttion: 
 * @version: 
 * @Author: ankeji
 * @Date: 2024-03-13 11:33:32
 * @LastEditors: ankeji
 * @LastEditTime: 2025-10-29 15:30:58
 */
//src/api/user/index.js

import service from "./request.js";
const baseUrl = "/dy_admin";
export function LoginInfo(query) {
  return service({
    method: "POST",
    url: baseUrl + "/self",
    data: query,
  });
}
export function addUserToDyUser3(query) {
  return service({
    method: "POST",
    url: baseUrl + "/addUserToDyUser3",
    data: query,
  });
}

export function updateUserInfo(query) {
  return service({
    method: "POST",
    url: baseUrl + "/updateUserInfo",
    data: query,
  });
}


export function updateSessionId(query) {
  return service({
    method: "POST",
    url: baseUrl + "/updateSessionId",
    data: query,
  });
}
export function getfaqList(query) {
  console.log(query);
  return service({
    method: "GET",
    url: baseUrl + "/faq",
    params: query,
  });
}